import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import io from 'socket.io-client';
import ViewAreaOfLaw from './AreaOfLaw';
import { updateRecord, viewEachRecord } from '../../services/areaOfLawServives';

function Categories(props) {
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const baseURL = process.env.REACT_APP_BASE_URL_DOCUMENT;

  useEffect(() => {
    async function getEach() {
      const id = props.match.params.id;
      viewEachRecord(id)
        .then((response) => {
          setName(response.data.name);
        })
        .catch((error) => {
          if (error.response.data.userError) {
            Cookies.remove('token');
            Cookies.remove('creadUseDetail');
            props.history.push('/');
            window.location.reload();
          }
        });
    }
    async function clientSocket() {
      const socket = io(baseURL);

      // Socket for update area of law record
      socket.on('updateAreaOfLaw', (ms) => {
        if (props.match.params.id === ms) {
          getEach();
        }
      });

      // Socket for delete area of law record
      socket.on('deleteAreaOfLaw', (ms) => {
        if (props.match.params.id === ms) {
          props.history.push('/cms/area-of-law');
        }
      });
    }
    clientSocket();
    getEach();
  }, [props.match.params.id]);

  async function handleSubmit() {
    if (name === '') {
      if (name === '') {
        setNameError('Area of law is required');
      } else {
        setNameError(null);
      }
    } else {
      setNameError(null);
      editData();
    }
  }

  async function editData() {
    const id = props.match.params.id;
    updateRecord(name, id)
      .then((response) => {
        const socket = io(baseURL);
        const userId = Cookies.get('creadUseDetail');
        socket.emit('areaOfLaw', `${userId}`);
        socket.emit('updateAreaOfLaw', `${props.match.params.id}`);
      })
      .catch((error) => {
        if (error.response.data.userError) {
          Cookies.remove('token');
          Cookies.remove('creadUseDetail');
          props.history.push('/');
          window.location.reload();
        }
      });
  }
  return (
    <div className="content-wrapper">
      <div>
        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Edit Area of Law</h1>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 col-12">
                <div className="card">
                  {/* /.card-header */}
                  <div className="card-body">
                    <div className="form-row">
                      <div className="col-12 form-group">
                        <label>
                          Add Area of Law<i className="required-detail">*</i>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name={name}
                          placeholder="Area of law"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        {nameError ? (
                          <p className="errorMessage"> {nameError}</p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="card-header">
                    <h3 className="card-title">
                      <Link
                        to="#"
                        onClick={() => handleSubmit()}
                        className="btn btn-info mr-2"
                      >
                        Update Record
                      </Link>
                    </h3>
                  </div>
                  {/* /.card-body */}
                </div>
                {/* /.card */}
                {/* /.card */}
              </div>
              <ViewAreaOfLaw />
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
    </div>
  );
}

export default Categories;
